<template>
<div class="px-md-10">
    <ValidationObserver ref="observer">
        <v-form @submit.prevent ="Reset">
            <v-row>
                <v-col cols="12" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                        <v-text-field @keyup.enter="Reset" :error-messages="errors" v-model="email" :disabled="ResetLoad" label="Email" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
            </v-row>
            <v-card-actions class="px-0 pb-6">
                <v-btn @click="Reset" block :loading="loading" color="blue darken-1 px-4" dark>Reset</v-btn>
            </v-card-actions>
            <div>
                <v-divider class="mb-4"></v-divider>
                <p class="grey--text text-center">Already a member? <router-link class="anchor--text font-weight-bold" to="/login">Login</router-link></p>
                <br>
            </div>
        </v-form>
    </ValidationObserver>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { required, email } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})
extend('email', {
    ...email,
    message: 'Email must be valid',
})
export default {
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data() {
        return {
            loading : false,
            valid: true,
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
        }
    },
    computed:{
        ...mapGetters(['ResetLoad'])
    },
    methods: {
        ...mapActions(['PostResponse']),
        ...mapMutations(['SnackbarSuccess', 'status_success']),
        Reset() {
            this.$refs.observer.validate().then(async (res) => {
                if (res) {
                    this.loading = true
                    try {
                        let value = {
                            url : '/internal/v2/forget-password',
                            data : { email : this.email }
                        }
                        const data = (await this.PostResponse(value)).data
                        if (data.success) {
                            this.loading = false
                            this.status_success(false)
                            this.email = ''
                            this.$refs.observer.reset();
                            this.$router.push('/')
                            let dataMsg = { success : true, message : data.message, action : 'success' }
                            this.SnackbarSuccess(dataMsg)
                        }
                    } catch (err) {
                        this.email = ''
                        this.$refs.observer.reset()
                        let dataMsg = { success : true, message : err.response.data.errors[0].message, action : 'error' }
                        this.SnackbarSuccess(dataMsg)
                        this.loading = false
                    }
                }
            })
        }
    },
    mounted() {
        this.$root.$on('resetValid', () => {
            this.email = '';
            this.$refs.observer.reset();
        })
    }

}
</script>
